"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
}); // src/definitions/environment.ts
var Environment = /* @__PURE__ */ function(Environment2) {
    Environment2["DEV"] = "DEV";
    Environment2["LOCAL"] = "LOCAL";
    Environment2["LOWER"] = "LOWER";
    Environment2["PRODUCTION"] = "PRODUCTION";
    return Environment2;
}(Environment || {});
function getBaseUrl(env) {
    switch(env){
        case "LOCAL" /* LOCAL */ :
            return "http://localhost:3000";
        case "DEV" /* DEV */ :
            return "https://accounts-pcid-dev.useast1-lower-gke1.lblw.cloud";
        case "LOWER" /* LOWER */ :
            return "https://accounts-lower.pcid.ca";
        case "PRODUCTION" /* PRODUCTION */ :
            return "https://accounts.pcid.ca";
    }
}
function getLoginUrl(env) {
    switch(env){
        case "LOCAL" /* LOCAL */ :
        case "DEV" /* DEV */ :
        case "LOWER" /* LOWER */ :
            return "https://accounts-lower.pcid.ca";
        case "PRODUCTION" /* PRODUCTION */ :
            return "https://accounts.pcid.ca";
    }
}
function getAudienceUrl(env) {
    switch(env){
        case "LOCAL" /* LOCAL */ :
        case "DEV" /* DEV */ :
        case "LOWER" /* LOWER */ :
            return "https://idcs-a656f8d8860a4b80bea15b03d86912c5.identity.oraclecloud.com";
        case "PRODUCTION" /* PRODUCTION */ :
            return "https://idcs-a0da8171e4814c39862d437e0aea2b6e.identity.oraclecloud.com";
    }
}
function getApiUrl(env) {
    switch(env){
        case "LOCAL" /* LOCAL */ :
        case "DEV" /* DEV */ :
            return "https://dev-pcid.api.loblaw.digital";
        case "LOWER" /* LOWER */ :
            return "https://sit-api.pcid.ca";
        case "PRODUCTION" /* PRODUCTION */ :
            return "https://api.pcid.ca";
    }
}
function getMyAccountUrl(env) {
    switch(env){
        case "LOCAL" /* LOCAL */ :
        case "DEV" /* DEV */ :
            return "https://myaccount-pcid-dev.useast1-lower-gke1.lblw.cloud/";
        case "LOWER" /* LOWER */ :
            return "https://myaccount-lower.pcid.ca/";
        case "PRODUCTION" /* PRODUCTION */ :
            return "https://myaccount.pcid.ca/";
    }
}
exports.Environment = Environment;
exports.getBaseUrl = getBaseUrl;
exports.getLoginUrl = getLoginUrl;
exports.getAudienceUrl = getAudienceUrl;
exports.getApiUrl = getApiUrl;
exports.getMyAccountUrl = getMyAccountUrl;
